import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Client from "../../entity/insurance/Client";

const SERVICE = "service-insurance";
const ENTITY = "clients";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Client(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application");
                }
            }
        }
    }
}
